import { BaseBrush } from './BaseBrush';
import { Grid } from '../Grid';
import { Empty } from '../particles/Empty';

export class Heater extends BaseBrush {
    name = 'heater';
    
    protected applyAt(x: number, y: number, grid: Grid, dist: number, maxDist: number): void {
        const particle = grid.get(x, y);
        if (particle && !particle.empty) {
            // 越靠近中心，加热效果越强
            // maxDist 是笔刷半径
            // 降低加热速度：边缘 0.5 度，中心 2.5 度
            const factor = maxDist > 0 ? (1 - dist / maxDist) : 1;
            const heatAmount = 0.5 + 2.0 * factor;
            
            particle.temperature += heatAmount;
            
            // 限制最高温
            if (particle.maxTemp) {
                particle.temperature = Math.min(particle.maxTemp, particle.temperature);
            }
        } else if (particle && particle.empty) {
             // 也可以加热空气？目前空气是 Empty，没有温度属性或者属性可能不被持久化（因为 Empty 通常是单例或者重新创建的）
             // Empty.ts 里有 temperature 属性，但是通常被视为空。
             // 如果想要热空气上升效果，可能需要把 Empty 变成 Air 粒子。
             // 暂时忽略空气加热。
        }
    }
}
